module.exports = __webpack_public_path__ + "img/creditcardlogo.db53821d.png";